// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const AddNonMemberWarningDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-addnonmemberwarningdialogcontainer" */ "./AddNonMemberWarningDialogContainer")).then((bundle)=>{
        return {
            default: bundle.AddNonMemberWarningDialogContainer
        };
    });
export const LazyAddNonMemberWarningDialogContainer = /*#__PURE__*/ lazy(AddNonMemberWarningDialogContainerLazyLoader);
